import { shallowEqual, useSelector } from "react-redux";
import CookieUtil from "../../utils/storage/cookieUtil";
import { isLocalMachine } from "../../utils/api/controlProxy";
import { returnEnvType } from "../../middleware";
import { useFnpChat } from ".";

/**
 * FNP chat wired to the signed-in customer (`user: null` = guest when logged out).
 * @returns {{ open: () => void, close: () => void }}
 */
export const useSiteFnpChat = () => {
  const { loginDetail, profile } = useSelector(
    (state) => ({ loginDetail: state?.fus?.loginDetail, profile: state?.loginSignUp?.userDetails }),
    shallowEqual,
  );
  const userLoginId = loginDetail?.loggedin ? loginDetail?.userLoginId : undefined;
  const session = typeof window !== "undefined" ? window.userDetails : undefined;
  return useFnpChat({
    clientUrl: process.env.NEXT_PUBLIC_FNP_CHAT_CLIENT_URL,
    config: { layout: { backdrop: false } },
    env: isLocalMachine() ? "local" : returnEnvType(window.location.hostname) === "prod" ? "prod" : "uat",
    user: userLoginId
      ? {
          userId: userLoginId,
          name: loginDetail?.fullname || profile?.userName,
          email: profile?.emailID || decodeURIComponent(CookieUtil.getCookie("faul") || ""),
          phone: profile?.mobNo,
          externalLoginKey: session?.externalLoginKey,
          sid: session?.sid,
        }
      : null,
  });
};
